import React from 'react';
import { Doughnut } from 'react-chartjs-2';
import { Empty } from 'antd';
import './chartSetup.ts';

interface DoughnutSlice {
  label: string;
  count: number;
  color: string;
}

interface StatusDoughnutProps {
  data: DoughnutSlice[];
}

// Doughnut riusabile (stati ordini, tipi spedizione, ...)
const StatusDoughnut: React.FC<StatusDoughnutProps> = ({ data }) => {
  const visible = data.filter(d => d.count > 0);

  if (visible.length === 0) {
    return (
      <div style={{ height: 280, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="Nessun dato" />
      </div>
    );
  }

  const chartData = {
    labels: visible.map(d => d.label),
    datasets: [
      {
        data: visible.map(d => d.count),
        backgroundColor: visible.map(d => d.color),
        borderWidth: 2,
        borderColor: '#fff',
      },
    ],
  };

  const options: any = {
    responsive: true,
    maintainAspectRatio: false,
    cutout: '65%',
    plugins: {
      legend: {
        position: 'right' as const,
        labels: { boxWidth: 12, font: { size: 11 } },
      },
    },
  };

  return (
    <div style={{ height: 280 }}>
      <Doughnut data={chartData} options={options} />
    </div>
  );
};

export default StatusDoughnut;
